import { versusTalksOk, nonChan, isVersus } from '../engine/versus';
import { useGame, useS } from '../store/game';
import { Panel, Sw } from '../components/ui';
import { PARTIES } from '../content/parties';
import { NEED } from '../content/consts';
import { PC, PN, satWith } from '../engine/rules';
import { coalSeats } from '../engine/election';
import { seatPoints } from '../engine/view';
import { de } from '../engine/util';
import { Illu } from '../components/Illu';
import { Hochrechnung } from './Hochrechnung';
import { TurnoutBox } from './Wahl9';
import { NewTag } from './govern/Parteien11';

export function Hemicycle() {
  const S = useS();
  const pts = seatPoints();
  const sel = new Set(['YOU', ...S.partners]);
  return (
    <svg className="hemi" viewBox="-104 -4 208 110" role="img" aria-label="Sitzverteilung im Bundestag">
      {pts.map((p: any, i: number) => <circle key={i} cx={(p.x * 100).toFixed(1)} cy={(100 - p.y * 100).toFixed(1)} r="1.6" fill={PC(p.pid)} opacity={S.phase === 'night' && S.partners.length && !sel.has(p.pid) ? .3 : 1} />)}
      <text x="0" y="98" textAnchor="middle" className="pl-num">{S.partners.length ? coalSeats() : 630}</text>
      <text x="0" y="105" textAnchor="middle" className="pl-cap">{S.partners.length ? 'Sitze der Koalition' : 'Sitze'}</text>
    </svg>
  );
}

export function Night() {
  const S = useS(); const { dispatch } = useGame();
  const all = ['YOU', ...Object.keys(PARTIES)].filter((id) => S.res.share[id] != null).sort((a, b) => S.res.share[b] - S.res.share[a]);
  const cs = coalSeats(), ok = cs >= NEED && S.partners.length >= 1, mv = (S as any).backVia === 'misstrauen';
  return (
    <section className="screen">
      <Illu src="/img/szene/wahlabend.webp" className="illu scene" />
      {mv ? <div><span className="label">{S.elYear} · Konstruktives Misstrauensvotum</span><h2>Die Regierung ist gestürzt, {S.name} übernimmt</h2></div>
        : <div><span className="label">Bundestagswahl {S.elYear} · Endergebnis{S.leg ? ` · ${S.leg + 1}. Legislatur` : ''}</span><h2>{S.name} wird stärkste Kraft mit {de(S.elec)} Prozent</h2></div>}
      {(S as any).makel > 0 && <p className="msg">Nach dem Sturz eurer früheren Regierung will keine Partei mit euch koalieren. Ihr regiert als Minderheitsregierung oder erneuert euch erst in der Opposition.</p>}
      {mv && <p>Der Bundestag hat eure Kandidatin zur Kanzlerin gewählt. Der Bundestag bleibt, wie er ist: Bildet jetzt eine Koalition mit den Parteien, die das Misstrauensvotum getragen haben.</p>}
      <p>Für eine Mehrheit braucht ihr {NEED} der 630 Sitze. Wählt bis zu drei Partner für Sondierungsgespräche. Ohne Mehrheit könnt ihr auch eine Minderheitsregierung bilden und euch für jedes Gesetz Stimmen in der Opposition suchen.</p>
      {!mv && <Hochrechnung />}
      <Hemicycle />
      <TurnoutBox res={S.res} prev={(S as any).resPrev} />
      <div className="tablewrap"><table className="ptable"><thead><tr><th>Partei</th><th className="n">Stimmen</th><th className="n">Sitze</th></tr></thead><tbody>
        {all.map((id) => <tr key={id}><td><Sw id={id} />{PN(id)}{S.leg > 0 && <NewTag id={id} prev={(S as any).resPrev} />}</td><td className="n">{de(S.res.share[id])} %</td><td className="n">{S.res.seats[id] ?? 'unter 5 %'}</td></tr>)}
      </tbody></table></div>
      <Panel title="Mögliche Partner">
        <div className="partners">{S.res.inP.filter((i: string) => i !== 'YOU').map((id: string) => { const fit = satWith(id, S.you); return (
          <button type="button" key={id} className="pcard" aria-pressed={S.partners.includes(id)} onClick={() => dispatch('pick', id)}>
            <span><Sw id={id} /><b>{PN(id)}</b></span>
            <span className="num">{S.res.seats[id]} Sitze</span>
            <span className="sub">Programm-Nähe zu euch: <span className={'num ' + (fit >= .8 ? 'up' : fit < .65 ? 'down' : 'warn')}>{Math.round(fit * 100)} %</span></span>
          </button>); })}</div>
        <div className="actions"><span className="num">{cs} / {NEED} Sitze</span>
          <button type="button" className="yes" disabled={!ok || !versusTalksOk()} onClick={() => dispatch('talks')}>Sondierung beginnen</button>
          {nonChan().filter((P) => S.partners.includes(P.pid) && P.offer === 'pending').map((P) => <span key={P.pid} className="sub">Warten auf die Antwort von {PN(P.pid)} (Mitspieler) …</span>)}
          {isVersus() && <button type="button" onClick={() => dispatch('mandateReturn')}>Auftrag zurückgeben</button>}
          {S.res.seats.YOU >= NEED && !S.partners.length && <button type="button" className="yes" onClick={() => dispatch('alone')}>Mit absoluter Mehrheit allein regieren</button>}
          {cs < NEED && <button type="button" onClick={() => dispatch(S.partners.length ? 'talks' : 'alone')}>{S.partners.length ? 'Als Minderheitsregierung verhandeln' : 'Allein als Minderheitsregierung regieren'}</button>}
          <span className="sub">{cs < NEED && S.partners.length ? 'Noch keine Mehrheit.' : ''}</span></div>
      </Panel>
    </section>
  );
}
